import { formatArrayToElSelect, formatPhoneNumber } from "./../../utils";
import api from "../../api";
import { PAGINATION_DEFAULT } from "@/const";
const state = {
  status: "",
  list: [],
  result: [],
  dbListByCompany: {
    TB: [],
    MTR: [],
    RB: []
  },
  pagination: PAGINATION_DEFAULT
};

const getters = {
  list_to_select: (state) =>
    formatArrayToElSelect(state.list, {
      label: "Name",
      value: "ClientCode"
    }),
  result_to_select: (state) => formatArrayToElSelect(state.result),
  isLoading: (state) => state.status === "loading",
  getCustomerByCode: (state) => (code) => {
    return state.list.filter((li) => li.CustomerCode === code);
  },
  getCustomerByName: (state) => (name) => {
    return state.list.filter((li) => li.Name === name);
  },
  getCustomerByClientCode: (state) => (code) => {
    return state.list.filter((li) => li.ClientCode === code);
  },
  listToCards: (state) => (company) => {
    let items = [];
    try {
      state.dbListByCompany[company].forEach((item) => {
        const phone = formatPhoneNumber(item.PhoneNumber);
        items.push({
          Image: "/static/images/avatar-2.jpg",
          PhoneNumber: phone,
          ...item
        });
      });
    } catch (_) {
      //
    }
    return items;
  },
  listToCards2: (state, getters, rootState) => {
    let items = [];
    try {
      state.dbListByCompany[rootState.user.user.CompanySelected].forEach(
        (item) => {
          const phone = formatPhoneNumber(item.PhoneNumber);
          items.push({
            Image: "/static/images/avatar-2.jpg",
            PhoneNumber: phone,
            ...item
          });
        }
      );
    } catch (_) {
      //
    }
    return items;
  },
  getLengthCompany: (state) => (company) =>
    state.dbListByCompany[company].length
};

const actions = {
  getCustomers: async ({ commit, rootState }) => {
    return await new Promise((resolve, reject) => {
      commit("loading");

      const company = rootState.user.user.CompanySelected;

      api
        .get("/api/customers", {
          timeout: 3 * 60 * 1000, // Espera hasta 3 minutos
          params: {
            "criteria.companyId": company,
            "criteria.page": 1,
            "criteria.limit": 9999,
            "criteria.skip": 0
          }
        })
        .then((resp) => {
          commit("success");
          commit("list", resp.data.Items);
          commit("dbListByCompany", {
            company: company,
            list: resp.data.Items
          });
          commit("SET_PAGINATION", {
            ...PAGINATION_DEFAULT,
            total: resp.data.ItemCount,
            currentPage: resp.data.CurrentPage
          });
          resolve(resp);
        })
        .catch((err) => {
          commit("error");
          reject(err);
        });
    });
  },
  getCustomers2: ({ commit, rootState }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      const company = rootState.user.user.CompanySelected;

      api
        .get("/api/customers", {
          timeout: 3 * 60 * 1000, // Espera hasta 3 minutos
          params: {
            "criteria.companyId": company,
            "criteria.page": 1,
            "criteria.limit": 10,
            "criteria.skip": 0
          }
        })
        .then((resp) => {
          commit("success");
          commit("list", resp.data.Items);
          commit("dbListByCompany", {
            company: company,
            list: resp.data.Items
          });
          resolve(resp);
        })
        .catch((err) => {
          commit("error");
          reject(err);
        });
    });
  },
  getCustomerByCriteria: ({ commit, rootState }, payload) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      const p = {
        "criteria.companyId": rootState.user.user.CompanySelected,
        "criteria.name": payload.name ?? undefined,
        "criteria.vatRegistrationNumber": payload.vat ?? undefined,
        "criteria.clasificaction": payload.clasificaction ?? undefined,
        "criteria.contract": payload.contract ?? undefined,
        "criteria.status": payload.status ?? undefined,
        "criteria.clientId": payload.customerCode ?? undefined
      };

      api
        .get("/api/customers", {
          params: p
        })
        .then((resp) => {
          commit("success");
          commit("result", resp.data.Items);
          resolve(resp);
        })
        .catch((err) => {
          commit("error");
          reject(err);
        });
    });
  }
};

const mutations = {
  loading: (state) => (state.status = "loading"),
  success: (state) => (state.status = "success"),
  error: (state) => (state.status = "error"),
  list: (state, list) => {
    state.list = list;
  },
  SET_PAGINATION: (state, pagination) => {
    state.pagination = pagination;
  },
  dbListByCompany: (state, payload) => {
    state.dbListByCompany[payload.company] = payload.list;
  },
  result: (state, result) => {
    state.result = result;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
